import { useClientSide } from '@carvana/merch-react-hooks';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import GeoModal from '@/common/helios/Modals/GeoModal';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useModalContext } from '~/context/new-cars/ModalContext';
import fetchNewCarDelivery from '~/services/common/fetchNewCarDelivery';

export default function GeolocationModal() {
  const { isGeolocationModalOpen, setGeolocationModalOpen } = useModalContext();
  const router = useRouter();
  const isClientSide = useClientSide();
  const trackEvent = useTrackEvent();

  const onSuccessfulZipChange = useCallback(() => {
    router.refresh();
  }, [router]);

  if (!isClientSide) return null;

  return (
    <GeoModal
      fetchDelivery={fetchNewCarDelivery}
      isGeolocationModalOpen={isGeolocationModalOpen}
      onSuccessfulZipChange={onSuccessfulZipChange}
      setGeolocationModalOpen={setGeolocationModalOpen}
      trackEvent={trackEvent}
    />
  );
}
